import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/windowFix.js'; // Importar primeiro para evitar conflitos
import './i18n'; // i18n (PT-BR / EN) — carrega antes do App
import App from './App.jsx';
import ErrorBoundary from './components/ui/ErrorBoundary.jsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
